import React from 'react';
import useSearchBarLogic from './SearchBarLogic';

// 스킨 import
import BasicSearchBarSkin from './skins/BasicSearchBarSkin';
import ModernSearchBarSkin from './skins/ModernSearchBarSkin';

// 스킨 맵
const skinMap: Record<string, React.ComponentType<any>> = {
  'basic': BasicSearchBarSkin,
  'modern': ModernSearchBarSkin
};

/**
 * SearchBar 컴포넌트
 */
const SearchBar: React.FC<any> = (props) => {
  const { componentData, mode } = props;
  
  // 로직 훅 사용
  const logicData = useSearchBarLogic(componentData || props, mode || 'preview');
  
  // 스킨 선택
  const skinName = (componentData || props).componentProps?.skin || (componentData || props).skin || 'basic';
  const SkinComponent = skinMap[skinName] || BasicSearchBarSkin;
  
  // 스킨 컴포넌트 직접 렌더링
  return <SkinComponent {...logicData} options={(componentData || props).componentProps} utils={props.utils} app={props.app} />;
};

export default SearchBar;